import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import zhTranslations from './locales/zh.json';
import jaTranslations from './locales/ja.json';
import arTranslations from './locales/ar.json';
import ptTranslations from './locales/pt.json';
import crkTranslations from './locales/crk.json';
import ojTranslations from './locales/oj.json';
import iuTranslations from './locales/iu.json';
import nvTranslations from './locales/nv.json';
import chrTranslations from './locales/chr.json';

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  zh: { translation: zhTranslations },
  ja: { translation: jaTranslations },
  ar: { translation: arTranslations },
  pt: { translation: ptTranslations },
  crk: { translation: crkTranslations },
  oj: { translation: ojTranslations },
  iu: { translation: iuTranslations },
  nv: { translation: nvTranslations },
  chr: { translation: chrTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      bindI18nStore: 'added removed',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    supportedLngs: ['en', 'es', 'fr', 'de', 'zh', 'ja', 'ar', 'pt', 'crk', 'oj', 'iu', 'nv', 'chr'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
  });

export default i18n;

